import { render } from "./ModalVideo.vue?vue&type=template&id=39312544"
import script from "./ModalVideo.vue?vue&type=script&lang=js"
export * from "./ModalVideo.vue?vue&type=script&lang=js"
script.render = render

export default script